import { render, staticRenderFns } from "./PendingQA.vue?vue&type=template&id=9330b46a&"
import script from "./PendingQA.vue?vue&type=script&lang=js&"
export * from "./PendingQA.vue?vue&type=script&lang=js&"
import style0 from "./PendingQA.vue?vue&type=style&index=0&id=9330b46a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports